import styled from 'styled-components'

import { device } from 'utils/style'

export const Row = styled.div<{ noMargin?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: ${({ noMargin }): string => (noMargin ? '0' : '16px')};
  width: 100%;

  :last-child {
    margin-bottom: 0;
  }

  @media ${device.laptop} {
    flex-wrap: wrap;
    flex-direction: row;
  }
`
